export default __webpack_public_path__ + "static/media/mindmap_neuro_visio_moteur.2cad8244.png";